<template>
  <ErrorLayout>
    <p>退会済みの為、ご利用いただけません。</p>
    <p>購入済のデジタルチケットやデジタルクーポンをご利用したい場合は下記よりご利用ください。</p>
    <a :href="mypageUrl">{{ mypageUrl }}</a>
  </ErrorLayout>
</template>

<script>
import ErrorLayout from '@/views/pages/ErrorLayout/index.vue';

export default {
  components: {
    ErrorLayout,
  },
  data(){
    return {
      mypageUrl: process.env.VUE_APP_MGFF_URL
    }
  },
};
</script>

<style lang="scss"></style>
